import { createSlice } from "@reduxjs/toolkit";
import { getAIStoryById } from "./UnderwriterActions";
import { IUnderWriterAIStorySlice } from "./Underwriter.types";

const initialState: IUnderWriterAIStorySlice = {
  AIstoryById: ""
};

const underwriterAIStorySlice = createSlice({
  name: "underwriterAIStory",
  initialState: initialState,
  reducers: {
    resetAIStory: (state) => {
      state.AIstoryById = "";
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getAIStoryById.fulfilled, (state, { payload }) => {
      state.AIstoryById = payload.data || "";
    });
  },
});

export const { resetAIStory } = underwriterAIStorySlice.actions;
export default underwriterAIStorySlice.reducer;
